import { render, staticRenderFns } from "./airServiceProduct.vue?vue&type=template&id=608060ef&"
import script from "./airServiceProduct.vue?vue&type=script&lang=js&"
export * from "./airServiceProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('608060ef')) {
      api.createRecord('608060ef', component.options)
    } else {
      api.reload('608060ef', component.options)
    }
    module.hot.accept("./airServiceProduct.vue?vue&type=template&id=608060ef&", function () {
      api.rerender('608060ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/airServiceProduct.vue"
export default component.exports